<template>
  <div class="filebox">
    <input
      id="file"
      ref="file"
      type="file"
      class="upload-hidden"
      :accept="accept"
      multiple
      @change="onSelectFile"
    />
    <label class="file-upload-btn btn" :class="btnStyle" for="file">{{
      title
    }}</label>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default:
        '.pdf,.xls, .xlsx, .hwp, .txt, .doc, .docx, .jpg, .gif, .wav, .mp4, .avi'
    },
    imageUrl: {
      type: String,
      default: ''
    },
    btnLabel: {
      type: String,
      default: '첨부파일'
    },
    useCancel: {
      type: Boolean,
      default: true
    },
    value: {
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    btnStyle: {
      type: String,
      default: 'small primary'
    },
    maxSize: {
      type: Number,
      default: 20971520 // 20MB
    }
  },
  data() {
    return {
      fileName: this.value
    }
  },
  computed: {
    fileAcceptValidator() {
      return this.accept.split(', ')
    }
  },
  watch: {
    value() {
      this.fileName = this.value
    },
    isFocus(val) {
      // console.log(123);
      if (val) {
        this.$refs.test.focus()
      }
    }
  },
  mounted() {},
  methods: {
    validateFile(file) {
      const { name: fileName, size: fileSize } = file
      // console.log(fileName, fileSize);

      // Validate Type - typeAccept is lowercase form
      const isFileTypeValid = this.fileAcceptValidator.some(typeAccept =>
        fileName.toLowerCase().endsWith(typeAccept)
      )

      // Validate Size
      const isSizeValid = !this.maxSize || fileSize <= this.maxSize

      if (!isFileTypeValid || !isSizeValid) {
        return false
      }

      return true
    },
    onSelectFile(event) {
      // this.$refs.file.value = null
      // console.log('Upload files: ', event.target.files[0])
      const fileList = Array.from(event.target.files)
      this.$emit('onSelectFile', fileList)
      // const isValid = fileList.every(file => this.validateFile(file))
      // if (isValid) {
      //   this.$emit('change', fileList)
      //   this.resetFile()
      // } else {
      //   this.$vxToastError(this.$messages.error.invalid_files)
      // }
    },
    onRemoveFile(index) {
      this.fileList.splice(index, 1)
    },
    resetFile() {
      this.$refs.file.value = ''
      // this.fileName = '';
    },
    getInputFile() {
      const files = this.$refs.file.files
      return files.length > 0 ? files[0] : null
    },
    downLoadFile() {
      // console.log('dowload file');
      this.$emit('downloadFile', '')
    }
  }
}
</script>

<style>
.border-primary {
  border: 1px solid #f07a26 !important;
}
.upload-hidden {
  display: none;
}
</style>
